import { z } from 'zod';
/** Códigos editables: UPPER_SNAKE e inmutables (convención de la suite). */
export const codeSchema = (max = 40) => z.string().trim().regex(/^[A-Z][A-Z0-9_]*$/, 'Usa MAYÚSCULAS, números y guion bajo, empezando por una letra').max(max);
export const toCode = (text, max = 40) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, '').replace(/^(\d)/, 'C_$1').slice(0, max) || 'CODIGO';
export const uuid = z.string().uuid();
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha AAAA-MM-DD');
export const name = (max = 200) => z.string().trim().min(1, 'Escribe un nombre').max(max);
/** Texto enriquecido: HTML que la API sanea antes de guardar. */
export const richText = z.string().max(100_000);
export const paginationSchema = z.object({
    limit: z.coerce.number().int().min(1).max(500).default(100),
    cursor: z.string().optional(),
});
/** Colores de etiqueta: índices de la paleta categórica `--etiqueta-1…12` de Xiltrion UI. Nunca hex. */
export const labelColor = z.number().int().min(1).max(12);
export const ActorKind = { USER: 'USER', SYSTEM: 'SYSTEM', AI: 'AI', INTEGRATION: 'INTEGRATION' };
//# sourceMappingURL=common.js.map